import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import paymentMethodApis from "../../apiConfigs/paymentMethods";
import settings from "../../apiConfigs/settings";
import DeleteModal from "../../designComponents/DeleteModal";
import requestAPI from "../../utils/requestAPI";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  SectionTitle,
  Title,
  Wrapper,
} from "../Properties/Details/styles";
import AddEditPaymentMethod from "./AddEditPaymentMethods";
import AddPlatformSettings from "./AddPlatformSettings";
import AddPromotion, { PricingSettings } from "./AddPromotion";
import AddStripeVerification from "./AddStripeVerification";
import ViewPaymentMethods, { PaymentMethodType } from "./ViewPaymentMethods";
import ViewPlatformFees from "./ViewPlaformFees";
import ViewPromos, { PropertyPromotion } from "./ViewPromos";
import ViewStripeFees from "./ViewStripeFees";
import ViewStripeVerificationFees from "./ViewStripeVerificationFees";
import ViewTaxPercentage from "./ViewTaxPercentage";
import AddEditTaxPercentageTrade from "./AddEditTaxPercentageTrade";
import AddEditVatPercentageTrade from "./AddEditVatPercentageTrade";
import ViewVatPercentage from "./ViewVatPercentage";

type AddEditPaymentStateType = {
  _id?: string;
  icon: string;
  visible: boolean;
  title: string;
  key: string;
  isActive: boolean;
  type?: "Add" | "Edit";
};

const GlobalSettings = () => {
  const [settingsData, setSettings] = useState<PricingSettings>({
    perDayRate: 0,
    clickInterval: 0,
    weeklyDiscountRate: 10,
    monthlyDiscountRate: 20,
    percentageFee: 0,
    flatFee: 10,
    currency: "EUR",
    stripeFeePercentage: 0,
    stripeFeeRate: 0,
    verificationFlatFee: 0,
    verificationPercentageFee: 0,
    lookupFlatFee: 0,
    lookupPercentageFee: 0,
    rentisityFlatFee: 0,
  });
  const handleDelete = async (id: string) => {
    try {
      await requestAPI(settings.deleteGlobalSettings(id));
      toast.success("Successfully Deleted");
      getGlobalSettings();
    } catch (error) {
      toast.error("Error Deleting");
    }
  };
  const [taxPercentage, setTaxPercentage] = useState<number>();
  const [vatPercentage, setVatPercentage] = useState<number>();
  const [addEditVatPercentageVisible, setAddEditVatPercentageVisible] =
    useState<boolean>(false);
  const [addEditTaxPercentageVisible, setAddEditTaxPercentageVisible] =
    useState<boolean>(false);

  const getGlobalSettings = async () => {
    try {
      const responsePromote = await requestAPI(
        settings.getGlobalSettingsPromote(),
      );
      setGlobalSettingsPromoteData(responsePromote);
      setGlobalSettingsPlatformFee(responsePromote);
      setGlobalSettingsStripeVerification(responsePromote);
      setTaxPercentage(responsePromote?.taxPercentage);
      setSettings({
        stripeFeePercentage: responsePromote?.stripeFee?.percentageFee,
        stripeFeeRate: responsePromote?.stripeFee?.flatFee,
        percentageFee: responsePromote?.platformFee?.percentageFee,
        flatFee: responsePromote?.platformFee?.flatFee,
        currency: "EUR",
        perDayRate: responsePromote?.promoteProperty?.perDayRate,
        weeklyDiscountRate:
          responsePromote?.promoteProperty?.weeklyDiscountRate,
        monthlyDiscountRate:
          responsePromote?.promoteProperty?.monthlyDiscountRate,
        clickInterval: responsePromote?.promoteProperty?.viewCountInterval,
        verificationFlatFee:
          responsePromote?.stripeVerification?.verification?.flatFee,
        verificationPercentageFee:
          responsePromote?.stripeVerification?.verification?.percentageFee,
        lookupFlatFee: responsePromote?.stripeVerification?.lookup?.flatFee,
        lookupPercentageFee:
          responsePromote?.stripeVerification?.lookup?.percentageFee,
        rentisityFlatFee: responsePromote?.stripeVerification?.flatFee,
      });
    } catch (error: any) {
      console.log(error.message);
      toast.error(error.message);
    }
  };
  const [globalSettingsPromoteData, setGlobalSettingsPromoteData] =
    useState<PropertyPromotion | null>();

  const [paymentMethods, setPaymentMethods] = useState<PaymentMethodType[]>([]);
  const [globalSettingsPlatformFee, setGlobalSettingsPlatformFee] =
    useState<PropertyPromotion | null>();

  const [
    globalSettingsStripeVerification,
    setGlobalSettingsStripeVerification,
  ] = useState<PropertyPromotion | null>();
  const handleAddSettingPromote = async () => {
    try {
      await requestAPI(
        settings.addGlobalSettingPromote({
          promoteProperty: {
            name: "STANDARD",
            currency: "EUR",
            description: ["static"],
            perDayRate: settingsData.perDayRate,
            monthlyDiscountRate: settingsData.monthlyDiscountRate,
            weeklyDiscountRate: settingsData.weeklyDiscountRate,
            viewCountInterval: settingsData.clickInterval ?? 1,
          },
        }),
      );
      getGlobalSettings();
      setAddPromoVisible(false);
      toast.success("Successfully Updated");
      // setSettings({
      //   perDayRate: 0,
      //   clickInterval: 0,
      //   weeklyDiscountRate: 10,
      //   monthlyDiscountRate: 20,
      //   percentageFee: 0,
      //   flatFee: 10,
      //   currency: "EUR",
      //   stripeFeePercentage: 0,
      //   stripeFeeRate: 0,
      //   verificationFlatFee: 0,
      //   verificationPercentageFee: 0,
      //   lookupFlatFee: 0,
      //   lookupPercentageFee: 0,
      //   rentisityFlatFee: 0,
      // });
    } catch (error) {}
  };
  const handleAddSettingPlatformFee = async () => {
    try {
      await requestAPI(
        settings.addGlobalSettingPlatformFee({
          flatFee: settingsData.flatFee,
          percentageFee: settingsData.percentageFee,
          currency: "EUR",
        }),
      );
      getGlobalSettings();
      setAddPlatformVisible(false);
      toast.success("Successfully Updated");
      // setSettings({
      //   perDayRate: 0,
      //   clickInterval: 0,
      //   weeklyDiscountRate: 10,
      //   monthlyDiscountRate: 20,
      //   percentageFee: 0,
      //   flatFee: 10,
      //   currency: "EUR",
      //   stripeFeePercentage: 0,
      //   stripeFeeRate: 0,
      //   verificationFlatFee: 0,
      //   verificationPercentageFee: 0,
      //   lookupFlatFee: 0,
      //   lookupPercentageFee: 0,
      //   rentisityFlatFee: 0,
      // });
    } catch (error) {}
  };

  const handleAddStripeVerificationFees = async () => {
    try {
      await requestAPI(
        settings.addVerificationStripeFee({
          verification: {
            flatFee: settingsData.verificationFlatFee ?? 0,
            percentageFee: settingsData.verificationPercentageFee ?? 0,
            currency: "EUR",
          },
          lookup: {
            flatFee: settingsData.lookupFlatFee ?? 0,
            percentageFee: settingsData.lookupPercentageFee ?? 0,
            currency: "EUR",
          },
          flatFee: settingsData.rentisityFlatFee ?? 0,
        }),
      );
      getGlobalSettings();
      setAddVerificationVisible(false);
      toast.success("Successfully Updated");
      setSettings({
        perDayRate: 0,
        clickInterval: 0,
        weeklyDiscountRate: 10,
        monthlyDiscountRate: 20,
        percentageFee: 0,
        flatFee: 10,
        currency: "EUR",
        stripeFeePercentage: 0,
        stripeFeeRate: 0,
        verificationFlatFee: 0,
        verificationPercentageFee: 0,
        lookupFlatFee: 0,
        lookupPercentageFee: 0,
        rentisityFlatFee: 0,
      });
    } catch (error) {}
  };
  useEffect(() => {
    getGlobalSettings();
    getAllPaymentMethods();
  }, []);
  const [addPromoVisible, setAddPromoVisible] = useState(false);
  const [addPlatformVisible, setAddPlatformVisible] = useState(false);
  const [addStripeVerificationVisible, setAddVerificationVisible] =
    useState(false);

  const INITIAL_PAYMENT_STATE: AddEditPaymentStateType = {
    icon: "",
    key: "",
    title: "",
    visible: false,
    isActive: false,
    type: undefined,
    _id: "",
  };
  const [addEditPaymentState, setAddEditPaymentState] =
    useState<AddEditPaymentStateType>(INITIAL_PAYMENT_STATE);

  const handleDeletePaymentMethod = async (id: string) => {
    try {
      await requestAPI(paymentMethodApis.deletePaymentMethodID(id));
    } catch (error) {
      console.error(error);
    } finally {
      setDeletePaymentState({ visible: false, paymentMethodId: "" });
      await getAllPaymentMethods();
    }
  };
  const handleAddUpdateTaxPercentage = async (taxPercentage: number) => {
    try {
      await requestAPI(settings.addUpdateTaxPercentage({ taxPercentage }));
    } catch (error) {
      console.error(error);
    } finally {
      setAddEditTaxPercentageVisible(false);
      await getGlobalSettings();
    }
  };
  const handleAddUpdateVatPercentage = async (vatPercentage: number) => {
    try {
      await requestAPI(settings.addUpdateVatPercentage({ vatPercentage }));
    } catch (error) {
      console.error(error);
    } finally {
      setAddEditVatPercentageVisible(false);
      await getGlobalSettings();
    }
  };

  const handleAddEditPaymentMethod = async (values: {
    icon: string | File;
    title: string;
    key: string;
    isActive: boolean;
  }) => {
    try {
      let providedUrl: string = "";
      if (values.icon && typeof values.icon !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [values.icon],
          assetsCategory: "Amenities",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
        }
      } else if (typeof values.icon === "string") {
        providedUrl = values.icon;
      }
      await requestAPI(
        paymentMethodApis.addEditPaymentMethod({
          ...values,
          icon: providedUrl,
          id: addEditPaymentState?._id,
        }),
      );
    } catch (err) {
      console.error(err, "ERROR While adding or editing payment methods");
    } finally {
      setAddEditPaymentState(INITIAL_PAYMENT_STATE);
      await getAllPaymentMethods();
    }
  };

  const getAllPaymentMethods = async () => {
    try {
      const response = await requestAPI(
        paymentMethodApis.getAllPaymentMethods(),
      );
      setPaymentMethods(response);
    } catch (error) {
      console.error(error);
    }
  };

  const [deletePaymentState, setDeletePaymentState] = useState<{
    paymentMethodId: string;
    visible: boolean;
  }>({ paymentMethodId: "", visible: false });

  return (
    <Wrapper>
      <Title>Global Settings</Title>
      <Card style={{ marginLeft: 0 }}>
        <ButtonsSection>
          <SectionTitle> Property Promotion Settings</SectionTitle>
          <AcceptButton
            onClick={() => {
              setAddPromoVisible(true);
            }}
          >
            Update
          </AcceptButton>
        </ButtonsSection>
        {globalSettingsPromoteData && (
          <ViewPromos
            handleDelete={handleDelete}
            globalSettingsData={globalSettingsPromoteData}
          ></ViewPromos>
        )}

        <AddPromotion
          initialValues={settingsData}
          setData={setSettings}
          onAddPress={handleAddSettingPromote}
          isOpen={addPromoVisible}
          onClose={() => {
            setAddPromoVisible(false);
          }}
        ></AddPromotion>
      </Card>
      <Card style={{ marginLeft: 0 }}>
        <ButtonsSection>
          <SectionTitle> Platform Fee Settings</SectionTitle>
          <AcceptButton
            onClick={() => {
              setAddPlatformVisible(true);
            }}
          >
            Update
          </AcceptButton>
        </ButtonsSection>
        {globalSettingsPlatformFee && (
          <ViewPlatformFees
            handleDelete={handleDelete}
            globalSettingsData={globalSettingsPlatformFee}
          ></ViewPlatformFees>
        )}
        <AddPlatformSettings
          initialValues={settingsData}
          setData={setSettings}
          onAddPress={handleAddSettingPlatformFee}
          isOpen={addPlatformVisible}
          onClose={() => {
            setAddPlatformVisible(false);
          }}
        ></AddPlatformSettings>
      </Card>

      <Card style={{ marginLeft: 0 }}>
        {globalSettingsPromoteData && (
          <ViewStripeFees
            globalSettingsData={globalSettingsPromoteData}
            refetchData={getGlobalSettings}
            paymentMethods={paymentMethods?.filter((pm) =>
              ["card", "bank"].includes(pm.key),
            )}
          />
        )}
      </Card>
      <Card style={{ marginLeft: 0 }}>
        <ButtonsSection>
          <SectionTitle> Stripe Verification Fee </SectionTitle>
          <AcceptButton
            onClick={() => {
              setAddVerificationVisible(true);
            }}
          >
            Update
          </AcceptButton>
        </ButtonsSection>
        {globalSettingsStripeVerification && (
          <ViewStripeVerificationFees
            globalSettingsData={globalSettingsStripeVerification}
          ></ViewStripeVerificationFees>
        )}
        <AddStripeVerification
          initialValues={settingsData}
          setData={setSettings}
          onAddPress={handleAddStripeVerificationFees}
          isOpen={addStripeVerificationVisible}
          onClose={() => {
            setAddVerificationVisible(false);
          }}
        ></AddStripeVerification>
      </Card>

      <AddEditPaymentMethod
        handleSubmit={async (values) => {
          await handleAddEditPaymentMethod(values);
        }}
        initialValues={{
          icon: addEditPaymentState?.icon,
          key: addEditPaymentState?.key,
          title: addEditPaymentState?.title,
          isActive: addEditPaymentState?.isActive,
        }}
        isOpen={addEditPaymentState?.visible}
        onClose={() => {
          setAddEditPaymentState(INITIAL_PAYMENT_STATE);
        }}
        type={addEditPaymentState?.type}
      />
      <DeleteModal
        isOpen={deletePaymentState?.visible}
        itemName="Payment Method"
        loading={false}
        onClose={() => {
          setDeletePaymentState({ paymentMethodId: "", visible: false });
        }}
        title="Are you sure you want to delete?"
        onDelete={async () => {
          await handleDeletePaymentMethod(deletePaymentState?.paymentMethodId);
        }}
      />
      <Card style={{ marginLeft: 0 }}>
        <ViewPaymentMethods
          data={paymentMethods}
          onDeleteClick={(id) => {
            setDeletePaymentState({ paymentMethodId: id, visible: true });
          }}
          onEditClick={({ icon, title, key, isActive, _id }) => {
            setAddEditPaymentState({
              type: "Edit",
              visible: true,
              icon,
              key,
              title,
              isActive,
              _id,
            });
          }}
          onAddClick={() => {
            setAddEditPaymentState({
              type: "Add",
              visible: true,
              icon: "",
              key: "",
              title: "",
              isActive: false,
            });
          }}
        />
      </Card>
      <AddEditTaxPercentageTrade
        handleSubmit={async (values) => {
          handleAddUpdateTaxPercentage(values.taxPercentage);
        }}
        initialValues={{
          taxPercentage: taxPercentage ?? 0,
        }}
        isOpen={addEditTaxPercentageVisible}
        onClose={() => {
          setAddEditTaxPercentageVisible(false);
        }}
        type={typeof taxPercentage === "number" ? "Edit" : "Add"}
      />
      <AddEditVatPercentageTrade
        handleSubmit={async (values) => {
          handleAddUpdateVatPercentage(values.vatPercentage);
        }}
        initialValues={{
          vatPercentage: vatPercentage ?? 0,
        }}
        isOpen={addEditVatPercentageVisible}
        onClose={() => {
          setAddEditVatPercentageVisible(false);
        }}
        type={typeof vatPercentage === "number" ? "Edit" : "Add"}
      />
      <Card style={{ marginLeft: 0 }}>
        <ViewVatPercentage
          data={{ vatPercentage: vatPercentage }}
          onEditClick={() => {
            setAddEditVatPercentageVisible(true);
          }}
          onAddClick={() => {
            setAddEditVatPercentageVisible(true);
          }}
        />
      </Card>
      <Card style={{ marginLeft: 0 }}>
        <ViewTaxPercentage
          data={{ taxPercentage: taxPercentage }}
          onEditClick={() => {
            setAddEditTaxPercentageVisible(true);
          }}
          onAddClick={() => {
            setAddEditTaxPercentageVisible(true);
          }}
        />
      </Card>
    </Wrapper>
  );
};

export default GlobalSettings;
